export const refreshToken = () => (

  fetch(`${process.env.REACT_APP_AUTH_HOST}/api/v1/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'include'
  })
    .then(handleResponse)
)

const handleResponse = (response) => (

  response.status === 401 ?
    failed() :
    response.json().then(success)
)

const failed = () => (
  Promise.reject('Authentication expired')
)

const success = ({data}) => (data)



// WEBPACK FOOTER //
// ./src/authorisation/fetch-with-retry/retry.js